import axios from "axios";
import { InsuranceType } from "../helpers/insurance";
import { API_KEY, API_URL } from "../env"

const api = axios.create();
api.defaults.baseURL = API_URL
api.defaults.headers = {
    authorization: 'Basic ' + Buffer.from(API_KEY).toString('base64')
}

export interface IContact{
    name?: string,
    phoneNumber?: string,
    insuranceType?: InsuranceType,
    ageRange?: number,
    insurancePayment?: number,
    isSmoking?: boolean,
    hadSurgery?: boolean, 
    medicinesRequired?: boolean,
    isDisabled?: boolean,
    hasLimitations?: boolean,
    workDescription?: string
}

export interface IReview{
    profilePhotoUrl: string,
    displayName: string,
    starRating: number,
    comment: string
}

export default {
    getReviews: async (): Promise<IReview[]> => {
        let config = { 
            baseUrl: api.defaults.baseURL,
            headers: api.defaults.headers
        }
        return (await api.get(api.defaults.baseURL + '/api/v1/reviews', config)).data;
    },

    postContact: async (contact:IContact, token: string, campaign?: string): Promise<boolean> => {
        let config = { 
            baseUrl: api.defaults.baseURL,
            headers: { 
                token:token,
                ...api.defaults.headers
            }}
        return (await api.post(api.defaults.baseURL + '/api/v1/contact?campaign=' + campaign, contact, config)).data.success;
    }, 

    sendToken: async(phoneNumber: string): Promise<boolean> => {
        return (await api.post(api.defaults.baseURL + '/api/v1/phone/verify/' + phoneNumber)).data.success;
    },

    sendTokenWithContact: async(phoneNumber: string, contact:IContact): Promise<boolean> => {
        return (await api.post(api.defaults.baseURL + '/api/v1/phone/verify/' + phoneNumber, contact)).data.success;
    },

    verifyToken: async(token: string): Promise<boolean> => {
        return (await api.post(api.defaults.baseURL + '/api/v1/tokens/approve/'+ token)).data.success;
    }
}